/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: =, Brian Bal
 */

 import React, { useEffect, useState } from "react"
 import { connect } from "react-redux"
 import {
     Modal,
     ModalTitle,
     TitleSection,
     FullGameDownloadNotAvailableContent
 } from "trux"
 import * as links from "../../util/links"
 import DownloadMomentWrapper from "../DownloadMomentWrapper"
 import { calculateNoOfDaysBeforeExpiration } from "../../util/helpers"
 import "./DownloadMomentDialog.css"
 
 const DownloadDialogComp = ({
     currentPlaylist,
     game,
     extras,
     history,
     onClose
 }) => {
     let open = !!(extras && (extras["download-options"] || extras["download-share"]))
     const [hideTitle, setHideTitle] = useState(false)

    let uploadTIme = game?.subtasks_statuses?.webapp_migration?.update_time
    let expirationDays =
        uploadTIme && calculateNoOfDaysBeforeExpiration(uploadTIme)
    let isFullVideoExpired =
        !expirationDays && currentPlaylist?.id === "full-game"
    let isFullVideoAvailable =
        expirationDays && currentPlaylist?.id === "full-game"

    useEffect(() => {
        if (open) {
            document.dispatchEvent(new CustomEvent("trc-pause"))
        }
    })

    const close = (e) => {
        if (typeof onClose === "function") {
            onClose(history)
        } else {
            history.goBack()
        }
    }

    return (
        <Modal
            trkContext="Download Moment Dialog"
            className="DownloadMoment"
            open={open}
            onShadeClick={close}
        >
            {!hideTitle && (
               <TitleSection onCloseClick={close}>
                   <ModalTitle content="Download moment" />
               </TitleSection>
            )}
            {currentPlaylist?.id !== "full-game" && open && (
                <DownloadMomentWrapper
                    onClose={() => history.goBack()}
                    onSetStep={(step) => { if (step === "auto-add") setHideTitle(true) }}
                />
            )}
            {isFullVideoAvailable && open && (
                <DownloadMomentWrapper
                    onClose={() => history.goBack()}
                    expirationDays={expirationDays}
                />
            )}
            {isFullVideoExpired && open && (
                <FullGameDownloadNotAvailableContent
                    history={history}
                    pathToReplace={"download"}
                />
            )}
        </Modal>
    )
}

const mapStateToProps = (state, props) => {
    let extras = links.getUrlExtras(window.location.hash)
    let teamName = props.match.params.team_name
    let gameId = props.match.params.game_id
    let fullGameEventNumber = 1
    let fullGameTime = 0
    let isFullGame = false
    let createEnabled = false
    let removeGoalEnabled = false
    let editEnabled = false
    let game = state.game.value
    let user = state.user.value
    let event = null
    let currentPlaylist = state.video.value.playlist
    let acl = state.acl.value

    if (state.video.value.source) {
        isFullGame = state.video.value.source.meta.type === "FullGameVideo"
    }

    if (state.acl.value && state.video.value.source) {
        createEnabled = state.acl.value.create_moment_tool
        editEnabled = state.video.value.source.meta.type !== "FullGameVideo"
        removeGoalEnabled = state.video.value.source.meta.type.includes("key")
    }

    if (state.game.value) {
        event = state.video.value.source
        let halfEvent = null
        let allEvents = state.game.value.events

        if (event) {
            for (let ev of allEvents) {
                if (ev.meta.type === "FullGameVideo") {
                    let hStart = ev.full_game_time
                    let hEnd = hStart + ev.dynamic.duration
                    if (
                        hStart <= event.full_game_time &&
                        event.full_game_time < hEnd
                    ) {
                        halfEvent = ev
                        fullGameEventNumber = ev.event_number
                        break
                    }
                }
            }
            if (event.meta.type === "FullGameVideo") {
                fullGameTime = event.full_game_time
            } else if (halfEvent) {
                fullGameTime = event.full_game_time
            }
        }
        let video = document.querySelector(`.VideoPlayer video.main-video[data-active=\"true\"]`)
        if (video) {
            console.log("fullGameTime video time offset", video.currentTime)
            fullGameTime += video.currentTime
        }
        fullGameTime = Math.round(fullGameTime)

        if (currentPlaylist === null) {
            currentPlaylist = { title: "", event_count: 0 }
        }
    }

    return {
        extras,
        teamName,
        gameId,
        fullGameEventNumber,
        fullGameTime,
        isFullGame,
        createEnabled,
        removeGoalEnabled,
        editEnabled,
        currentPlaylist,
        game,
        user,
        event,
        acl,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {}
}

const DownloadMomentDialog = connect(
    mapStateToProps,
    mapDispatchToProps
)(DownloadDialogComp)
export default DownloadMomentDialog
